import Typography from '@classify/react-core-components/Typography';
import { useTheme } from '@classify/react-core-components/styles';
import { makeStyles } from '@mui/styles';
import { useMediaQuery } from '@mui/material';
import { Avatar } from '@openclassrooms/ui-web/ui';

import type { CourseTeacher } from '../../types';

interface CourseTeachersProps {
  teachers: Array<CourseTeacher>;
}

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  teachersContentWrapper: {
    display: 'flex',
    marginTop: spacing(2),

    [breakpoints.up('sm')]: {
      marginTop: spacing(3),
    },
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: spacing(2),
  },
}));

const CourseTeachers = ({ teachers }: CourseTeachersProps) => {
  const classes = useStyles();
  const { breakpoints } = useTheme();
  const isDesktop = useMediaQuery(breakpoints.up('md'));

  return (
    <>
      {teachers.map((teacher) => (
        <div key={teacher.id} className={classes.teachersContentWrapper}>
          <Avatar
            size={!isDesktop ? Avatar.SIZE_MEDIUM : Avatar.SIZE_LARGE}
            avatarUrl={teacher.profilePicture}
          />

          <div className={classes.textContent}>
            <Typography variant="h6" component="h4">
              {teacher.displayName}
            </Typography>

            <Typography variant="body">{teacher.miniBiography}</Typography>
          </div>
        </div>
      ))}
    </>
  );
};

export default CourseTeachers;
